import { render, staticRenderFns } from "./BonusInterface.vue?vue&type=template&id=2384ab08&scoped=true&"
import script from "./BonusInterface.vue?vue&type=script&lang=js&"
export * from "./BonusInterface.vue?vue&type=script&lang=js&"
import style0 from "./BonusInterface.vue?vue&type=style&index=0&id=2384ab08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384ab08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
